// extracted by mini-css-extract-plugin
module.exports = {"backgroundCinza":"style_backgroundCinza__3zaDD"};